import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TReferralsPartnersRequest,
	TReferralsPartnersResponse,
	TReferralsStore,
	TPartnersRequest,
	TPartnersResponse,
	TCreateReferralPartnersRequest,
	TAvailableEmsResponse,
	TCreatePartnerRequest,
	TUpdatePartnerRequest,
	TPartnerReportsRequest,
	TPartnerReportsResponse,
	TDownloadPartnerReportRequest,
} from './types';
// ==========================================:
export const initialState: TReferralsStore = {
	referralsPartners: null,
	referralsPartnersLoader: false,
	partners: null,
	partnersLoader: false,
	createReferralPartnersLoader: false,
	availableEms: null,
	availableEmsLoader: false,
	createPartnerLoader: false,
	updatePartnerLoader: false,
	partnerReports: null,
	partnerReportsLoader: false,
	downloadingPartnerReportIds: [],
};

// ==========================================:
const referrals = createSlice({
	name: '@@referrals',
	initialState,
	reducers: {
		getReferralsPartnersRequest: (
			state: TReferralsStore,
			action: PayloadAction<TReferralsPartnersRequest>,
		) => {
			const referralsState = state;
			referralsState.referralsPartnersLoader = true;
		},
		getReferralsPartnersSuccess: (
			state: TReferralsStore,
			action: PayloadAction<TReferralsPartnersResponse>,
		) => {
			const { payload } = action;
			const referralsState = state;
			referralsState.referralsPartners = payload;
			referralsState.referralsPartnersLoader = false;
		},

		getPartnersRequest: (state: TReferralsStore, action: PayloadAction<TPartnersRequest>) => {
			const referralsState = state;
			referralsState.partnersLoader = true;
		},
		getPartnersSuccess: (state: TReferralsStore, action: PayloadAction<TPartnersResponse>) => {
			const { payload } = action;
			const referralsState = state;
			referralsState.partners = payload;
			referralsState.partnersLoader = false;
		},

		createReferralPartnersRequest: (
			state: TReferralsStore,
			action: PayloadAction<TCreateReferralPartnersRequest>,
		) => {
			const referralsState = state;
			referralsState.createReferralPartnersLoader = true;
		},

		createReferralPartnersSuccess: (state: TReferralsStore) => {
			const referralsState = state;
			referralsState.createReferralPartnersLoader = false;
		},

		getAvailableEmsRequest: (state: TReferralsStore) => {
			const referralsState = state;
			referralsState.availableEmsLoader = true;
		},

		getAvailableEmsSuccess: (
			state: TReferralsStore,
			action: PayloadAction<TAvailableEmsResponse>,
		) => {
			const referralsState = state;
			referralsState.availableEms = action.payload;
			referralsState.availableEmsLoader = false;
		},

		createPartnerRequest: (
			state: TReferralsStore,
			action: PayloadAction<TCreatePartnerRequest>,
		) => {
			const referralsState = state;
			referralsState.createPartnerLoader = true;
		},

		createPartnerSuccess: (state: TReferralsStore) => {
			const referralsState = state;
			referralsState.createPartnerLoader = false;
		},

		updatePartnerRequest: (
			state: TReferralsStore,
			action: PayloadAction<TUpdatePartnerRequest>,
		) => {
			const referralsState = state;
			referralsState.updatePartnerLoader = true;
		},

		updatePartnerSuccess: (state: TReferralsStore) => {
			const referralsState = state;
			referralsState.updatePartnerLoader = false;
		},

		getPartnerReportsRequest: (
			state: TReferralsStore,
			action: PayloadAction<TPartnerReportsRequest>,
		) => {
			const referralsState = state;
			referralsState.partnerReportsLoader = true;
		},

		getPartnerReportsSuccess: (
			state: TReferralsStore,
			action: PayloadAction<TPartnerReportsResponse>,
		) => {
			const referralsState = state;
			referralsState.partnerReports = action.payload;
			referralsState.partnerReportsLoader = false;
		},

		getPartnerReportsFailure: (state: TReferralsStore) => {
			const referralsState = state;
			referralsState.partnerReportsLoader = false;
		},

		downloadPartnerReportRequest: (
			state: TReferralsStore,
			action: PayloadAction<TDownloadPartnerReportRequest>,
		) => {
			const referralsState = state;
			if (!referralsState.downloadingPartnerReportIds.includes(action.payload.id)) {
				referralsState.downloadingPartnerReportIds.push(action.payload.id);
			}
		},

		downloadPartnerReportFinished: (state: TReferralsStore, action: PayloadAction<number>) => {
			const referralsState = state;
			referralsState.downloadingPartnerReportIds =
				referralsState.downloadingPartnerReportIds.filter(id => id !== action.payload);
		},

		assetsInitState: () => initialState,
	},
});

export default referrals.reducer;
export const {
	getReferralsPartnersRequest,
	getReferralsPartnersSuccess,
	getPartnersRequest,
	getPartnersSuccess,
	createReferralPartnersRequest,
	createReferralPartnersSuccess,
	getAvailableEmsRequest,
	getAvailableEmsSuccess,
	createPartnerRequest,
	createPartnerSuccess,
	updatePartnerRequest,
	updatePartnerSuccess,
	getPartnerReportsRequest,
	getPartnerReportsSuccess,
	getPartnerReportsFailure,
	downloadPartnerReportRequest,
	downloadPartnerReportFinished,
	assetsInitState,
} = referrals.actions;
